import { render, staticRenderFns } from "./microsoft365.vue?vue&type=template&id=70f393d7&scoped=true"
import script from "./microsoft365.vue?vue&type=script&lang=js"
export * from "./microsoft365.vue?vue&type=script&lang=js"
import style0 from "./microsoft365.vue?vue&type=style&index=0&id=70f393d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f393d7",
  null
  
)

export default component.exports